<script setup lang="ts">
import HasPermission from "@/components/HasPermission.vue";
import { User } from "@/modules/users/interfaces/user";
import { Role } from "../composables/useRoles";

interface Props {
  member: User;
  role: Role;
  permissionToAssign: string;
  module: string;
}

interface Emits {
  (e: "removeMember", id: number): void;
}

defineProps<Props>();

const emits = defineEmits<Emits>();
</script>

<template>
  <div class="flex items-center justify-between w-full gap-4 mb-2 mt-2">
    <p class="text-sm md:text-lg">
      {{ `${member?.fullName} ` }}
      <span class="text-sm pl-5">
        ({{ member?.email ?? "No tiene correo" }})
      </span>
    </p>

    <HasPermission :name-permission="permissionToAssign" :entity-type="module">
      <button
        v-if="role.name !== 'Master'"
        class="material-symbols-outlined text-[18px] text-black rounded-full font-semibold p-[1px] hover:bg-gray-200 transition-colors"
        @click="emits('removeMember', member.id)"
      >
        close
      </button>
    </HasPermission>
  </div>
</template>

<style scoped></style>
